import {ScrollArea} from '@mantine/core';
import type {GetCompanyPageColumnPostsResponse} from '../../../../../core/repositories/companyDetailRepository';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {useWindowSize} from '../../../../../shared/services/useWindowSize';
import {ColumnCard} from '../../ColumnCard';
import {SectionTitle} from './SectionTitle';

type Props = {
  companyName?: string;
  specialPosts: GetCompanyPageColumnPostsResponse;
};

export const CompanySpecialPosts: React.FC<Props> = ({
  companyName,
  specialPosts,
}) => {
  const {isPC} = useMediaQuery();
  const {width} = useWindowSize();

  if (specialPosts.posts === undefined || specialPosts.posts.length === 0) {
    return null;
  }

  return (
    <div className="mt-8 pc:mt-16">
      <SectionTitle id="special-column" sectionTitle={`${companyName}の研究`} />
      <div
        className="mt-8 pc:mt-16"
        style={{width: isPC ? undefined : width - 32}}
      >
        <ScrollArea offsetScrollbars>
          <div className="flex gap-16">
            {specialPosts.posts.map((column) => (
              <ColumnCard key={column.id} post={column} isSponsored={false} />
            ))}
          </div>
        </ScrollArea>
      </div>
    </div>
  );
};
